import ActivityNavigator from "@plugins/activity-navigator/components/ActivityNavigator";

const Plugin = {
  install(app) {
    app.component("activity-navigator", ActivityNavigator);
  },
};

export default Plugin;
